import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="47"
      height="20"
      fill="none"
      viewBox="0 0 47 20"
    >
      <path
        fill="#fff"
        d="M26.413 18.85a.316.316 0 01-.314-.254c-.035-.185-.333-1.859-.025-4a12.253 12.253 0 011.004-3.428 11.12 11.12 0 012.52-3.463c2.362-2.2 5.11-2.935 7.095-3.153V.547c0-.125.076-.237.193-.286a.326.326 0 01.346.06l9.248 8.505a.307.307 0 010 .452l-9.248 8.506a.326.326 0 01-.346.06.311.311 0 01-.193-.286v-4.752a11.83 11.83 0 00-5.099 1.243 11.738 11.738 0 00-4.902 4.64.32.32 0 01-.279.16zM9.402.235a.93.93 0 00-.933.926v9.925L6.283 8.918c-.879-.845-2.173.433-1.319 1.308l3.778 3.747c.353.363.966.352 1.32 0l3.778-3.747c.851-.873-.436-2.154-1.32-1.308l-2.185 2.168V1.16a.93.93 0 00-.933-.926z"
      ></path>
      <mask
        id="mask0_795_882"
        style={{ maskType: "luminance" }}
        width="18"
        height="8"
        x="0"
        y="12"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#fff" d="M.91 12.385H17.86v6.975H.91v-6.975z"></path>
      </mask>
      <g mask="url(#mask0_795_882)">
        <path
          fill="#fff"
          d="M1.844 12.394a.93.93 0 00-.933.925v1.365c0 2.577 2.114 4.673 4.711 4.673h7.557c2.598 0 4.711-2.096 4.711-4.672v-1.366a.93.93 0 00-.933-.925.93.93 0 00-.932.925v1.365c0 1.557-1.277 2.822-2.846 2.822H5.622c-1.568 0-2.845-1.265-2.845-2.822V13.32a.93.93 0 00-.933-.926z"
        ></path>
      </g>
    </svg>
  );
}

export default Icon;
